import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  id: string;
  type: "success" | "error" | "warning" | "info";
  message: string;
  duration?: number;
}

interface UIState {
  notifications: Notification[];
  isGlobalLoading: boolean;
  loadingStates: Record<string, boolean>;
}

const initialState: UIState = {
  notifications: [],
  isGlobalLoading: false,
  loadingStates: {},
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    addNotification: (
      state,
      action: PayloadAction<Omit<Notification, "id">>,
    ) => {
      const notification: Notification = {
        id: Date.now().toString(),
        ...action.payload,
      };
      state.notifications.push(notification);
    },

    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload,
      );
    },

    clearNotifications: (state) => {
      state.notifications = [];
    },

    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isGlobalLoading = action.payload;
    },

    setLoadingState: (
      state,
      action: PayloadAction<{ key: string; isLoading: boolean }>,
    ) => {
      const { key, isLoading } = action.payload;
      if (isLoading) {
        state.loadingStates[key] = true;
      } else {
        delete state.loadingStates[key];
      }
    },

    clearLoadingState: (state, action: PayloadAction<string>) => {
      delete state.loadingStates[action.payload];
    },
  },
});

export const {
  addNotification,
  removeNotification,
  clearNotifications,
  setGlobalLoading,
  setLoadingState,
  clearLoadingState,
} = uiSlice.actions;

export default uiSlice.reducer;
